import { setup } from "xstate";
export const PROJECT_STATE_MACHINE_INITIAL = "opportunity";
export function makeProjectStateMachine(initial, { guards }) {
    return setup({
        types: {
            context: {},
            events: {},
        },
    })
        .createMachine({
        strict: true,
        id: "projectState",
        initial,
        context: {},
        states: {
            opportunity: {
                on: {
                    // @ts-ignore FIXME
                    CONTRACTOR_DECLINE: {
                        target: "contractor_declined",
                        guard: "isContractor",
                    },
                    CONTRACTEE_DECLINE: {
                        target: "contractee_declined",
                    },
                    WIN: {
                        target: "contracted",
                    },
                },
            },
            contractor_declined: {},
            contractee_declined: {},
            contracted: {
                on: {
                    CANCEL: { target: "cancelled" },
                    COMPLETE: { target: "completed" },
                },
            },
            legacy_closed: { type: "final" },
            cancelled: { type: "final" },
            completed: { type: "final" },
        },
    })
        .provide({
        guards: { isContractor: () => guards.isContractor === true },
    });
}
// const actor = createActor(projectStateMachine);
// actor.start();
// const nextEvents = actor.getSnapshot()._nodes.flatMap(sn => sn.ownEvents);
// actor.send({ type: "COMPLETE" });
//# sourceMappingURL=project.js.map